import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Iconos from "../IconosDeSitio";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SearchIcon from "@mui/icons-material/Search";
import AddIconWhite from "../../Img/Iconos/AgregarBlanco.svg"

// Importando acordiones
import Acordiones from "./HistoriaClinica/AcordionesHistorialClinico";
import "./styles/ExpedienteNuevoDetalle.scss";


// Impotando componentes
import RecetasExpedientes from "./RecetasExpedientes/RecetasExpedientes";
import EstudiosExpediente from "./EstudiosYanalisis/EstudiosExpediente";
import ExpedienteNotasMedicas from "./NotasMedicas/ExpedienteNotasMedicas";
import DocumentHistoryFiles from './HistorialDocumentos/DocumentHistoryFiles';
import { getHistoriasClinicas_request } from "../../services/expediente_service";
import { getMedicalDocuments } from '../../services/documents_services';
import { Content } from "antd/es/layout/layout";
import { Avatar, Button, Divider, Image, Input, Layout, Menu, Row, Typography } from "antd";
import { useEffect } from "react";
import { UseModal } from "../../hooks/UseModal";

import { Loader } from "../GeneralComponents/Loader";
import NewHistorialClinico from "./HistoriaClinica/newHistoriaClinica";
import Sider from "antd/es/layout/Sider";
import NewNavbar from "../GeneralComponents/Navbar_Nuevo";
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Stack, Snackbar, Alert as MuiAlert, CircularProgress, Paper } from "@mui/material";
import GrowthChart from "../Consultas/GrowthChart";
import ImmunizationRecords from "../Consultas/ImmunizationRecords";
import { getVaccines_request } from "../../services/vaccines_services";
import { getGrowthIndicators_request } from "../../services/growthIndicators_services";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function NewViewExpedienteNuevoDetalle() {
    let data = JSON.parse(sessionStorage.getItem("infoUser"));
    const userProfessions = useSelector((state) => state.userInfo.profesiones);

    const location = useLocation();
    const [isOpenModalAddNota, OpenModalAddNota, CloseModalAddNota] = UseModal(false);
    const [isOpenModalNuevaReceta, OpenModalNuevaReceta, CloseModalNuevaReceta] = UseModal(false);
    const [isOpenModalAddEstudi, OpenModalAddEstudi, CloseModalAddEstudi] = UseModal(false);
    const [isOpenModalAddMedicalFile, OpenModalAddMedicalFile, CloseModalAddMedicalFile] = UseModal(false);
    const [isOpenModalDetalleEstudi, OpenModalDetalleEstudi, CloseModalDetalleEstudi] = UseModal(false);

    const [DatosContacto, setDatosContacto] = useState({
        id: !!location.state ? location.state.id : sessionStorage.getItem("idContactoExpediente"),
        nombre: !!location.state ? location.state.nombre : sessionStorage.getItem("nombreContactoExpediente"),
        imagen: !!location.state ? location.state.imagen : sessionStorage.getItem("imagenContactoExpediente")
    });

    // UseState de las pestañas
    const [OpcionSelectExp, setOpcionSelectExp] = useState(1);

    const [Edad, setEdad] = useState(0);
    const [TipoSangre, setTipoSangre] = useState("");
    const [Celular, setCelular] = useState("");

    const [AccionesBoton, setAccionesBoton] = useState(() => { });
    const [ListaPrin, setListaPrin] = useState([]);
    const [ListaFilter, setListaFilter] = useState([]);

    const [NotasEvolucion, setNotasEvolucion] = useState([]);
    const [NotasEvolucionFilter, setNotasEvolucionFilter] = useState([]);

    const [ListaRecetas, setListaRecetas] = useState([]);
    const [ListaRecetasFilter, setListaRecetasFilter] = useState([]);

    const [ListaEstudios, setListaEstudios] = useState([]);
    const [ListaEstudiosFilter, setListaEstudiosFilter] = useState([]);
    const [documentHistories, setDocumentHistories] = useState([]);
    const [loadHistory, setLoadHistory] = useState(false);

    const [Historial, setHistorial] = useState({
        ficha: null,
        historial: null
    });

    const [loader, setLoader] = useState(false);

    // MANEJA DE MENSAJES
    const [open, setOpen] = useState(false);
    const [typeMessage, setTypeMessage] = useState("");
    const [message, setMessage] = useState("");

    const [isPediatra, setIsPediatra] = useState(!!userProfessions.find(item => item.Profesion === 'Pediatría'));
    const [vaccines, setVaccines] = useState([]);
    const [growthIndicators, setGrowthIndicators] = useState([]);

    const getGrowthIndicators = async (IdContacto) => {
        try {
            const indicators = await getGrowthIndicators_request(IdContacto);
            setGrowthIndicators(indicators);
        } catch (e) {
            setOpen(true);
            setTypeMessage("error");
            setMessage(e.message);
        }
    };

    const getVaccines = async (IdContacto) => {
        try {
            let vaccines = await getVaccines_request(IdContacto, { full: true });
            setVaccines(vaccines);
        } catch (e) {
            setOpen(true);
            setTypeMessage("error");
            setMessage(e.message);
        };
    };

    useEffect(() => {
        if (isPediatra) {
            getVaccines(DatosContacto.id);
            getGrowthIndicators(DatosContacto.id);
        }
    }, [DatosContacto.id]);


    async function getHistoriaClinica() {
        setLoader(true);
        let response = await getHistoriasClinicas_request(DatosContacto.id);
        if (response.ok) {
            setHistorial({ ficha: response.data.ficha, historial: response.data.historial })
            if (response.data.ficha != null) {
                setCelular(response.data.ficha.celular);
            }
            if (response.data.consultas != null) {
                setNotasEvolucion(response.data.consultas);
                setNotasEvolucionFilter(response.data.consultas);
            }
            if (response.data.recetas != null) {
                setListaRecetas(response.data.recetas);
                setListaRecetasFilter(response.data.recetas);
            }

            let array = [];
            if (response.data.estudios != null) {
                response.data.estudios.forEach(element => {
                    array.push({ id: element.id, descripcion: !!element.descripcion ? element.descripcion : "Sin descripción", fecha: element.fecha })
                });
            }

            const mapa = new Map();
            const arraySinDuplicados = array.filter((obj) => {
                return !mapa.has(obj.id) && mapa.set(obj.id, 1);
            });

            setListaEstudios(arraySinDuplicados);
            setListaEstudiosFilter(arraySinDuplicados);
        } else {
            setOpen(true);
            setTypeMessage("error");
            setMessage(response.mensaje);
        }
        setLoader(false);
        return;
    }

    async function retrieveMedicalHistoryFiles() {
        setLoadHistory(true);
        try {
            await getMedicalDocuments(DatosContacto.id).then(response => {
                const { documents } = response;

                setDocumentHistories(documents);
                setLoadHistory(false);
            }).catch(error => {
            });
        } catch (error) {
            console.error(error);
            setLoadHistory(false);
        }
    }

    function filterList(text) {
        var chars = {
            "á": "a", "é": "e", "í": "i", "ó": "o", "ú": "u",
            "à": "a", "è": "e", "ì": "i", "ò": "o", "ù": "u", "ñ": "n",
            "Á": "A", "É": "E", "Í": "I", "Ó": "O", "Ú": "U",
            "À": "A", "È": "E", "Ì": "I", "Ò": "O", "Ù": "U", "Ñ": "N"
        }
        var expr = /[áàéèíìóòúùñ]/ig;
        let filter = [];


        if (OpcionSelectExp === 2) {
            NotasEvolucionFilter.forEach((consulta) => {
                if (consulta.motivo.replace(expr, function (e) { return chars[e] }).toLowerCase().indexOf(text.target.value.replace(expr, function (e) { return chars[e] }).toLowerCase()) > -1 ||
                    consulta.fecha.replace(expr, function (e) { return chars[e] }).toLowerCase().indexOf(text.target.value.replace(expr, function (e) { return chars[e] }).toLowerCase()) > -1) {
                    filter.push(consulta);
                }
            });

            setNotasEvolucion(filter);
        }

        if (OpcionSelectExp === 3) {
            ListaRecetasFilter.forEach((receta) => {
                if (receta.folio.replace(expr, function (e) { return chars[e] }).toLowerCase().indexOf(text.target.value.replace(expr, function (e) { return chars[e] }).toLowerCase()) > -1 ||
                    receta.fecha.replace(expr, function (e) { return chars[e] }).toLowerCase().indexOf(text.target.value.replace(expr, function (e) { return chars[e] }).toLowerCase()) > -1) {
                    filter.push(receta);
                }
            });
            setListaRecetas(filter);
        }

        if (OpcionSelectExp === 4) {
            ListaEstudiosFilter.forEach((estudio) => {
                if (estudio.descripcion.replace(expr, function (e) { return chars[e] }).toLowerCase().indexOf(text.target.value.replace(expr, function (e) { return chars[e] }).toLowerCase()) > -1 ||
                    estudio.fecha.replace(expr, function (e) { return chars[e] }).toLowerCase().indexOf(text.target.value.replace(expr, function (e) { return chars[e] }).toLowerCase()) > -1) {
                    filter.push(estudio);
                }
            });

            setListaEstudios(filter);
        }

        if (OpcionSelectExp === 5) {
            documentHistories.forEach((document) => {
                if (document.NombreMultimedia.replace(expr, function (e) { return chars[e] }).toLowerCase().indexOf(text.target.value.replace(expr, function (e) { return chars[e] }).toLowerCase()) > -1 ||
                    document.Fecha.replace(expr, function (e) { return chars[e] }).toLowerCase().indexOf(text.target.value.replace(expr, function (e) { return chars[e] }).toLowerCase()) > -1) {
                    filter.push(document);
                }
            });

            setDocumentHistories(filter);
        }
    }

    useEffect(() => {
        getHistoriaClinica();
    }, []);

    return (
        <Layout>

            <NewNavbar
                showBanner={false}
                mensajesError={{
                    setOpen: setOpen,
                    setTypeMessage: setTypeMessage,
                    setMessage: setMessage,
                }}
                searchBar={
                    <>
                        <div className="CebezeraExpedientes">
                            <div
                                className="Encabesado-Expedientes"
                                style={{ alignItems: "center" }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "70%",
                                        alignItems: "center",
                                        gap: "1%",
                                    }}
                                >
                                    <div>
                                        <Link to="/app/Expedientes">
                                            <img className="ImgsNotas" src={Iconos[23]} alt="" />
                                        </Link>
                                    </div>
                                    <div>
                                        {" "}

                                        <Avatar style={{ display: "flex", alignItems: "center", justifyContent: "center" }} size={55}
                                            className="GeneralNoImage"
                                            src={
                                                <Image
                                                    src={
                                                        !!DatosContacto.imagen ? `https://${DatosContacto.imagen}` : Iconos[0]
                                                    }
                                                />
                                            } />
                                    </div>
                                    <div>
                                        <b style={{ fontSize: "120%" }}>{DatosContacto.nombre}</b>
                                        <p style={{ margin: "0", padding: "0" }}>Celular: {Celular} </p>
                                        <p style={{ margin: "0", padding: "0" }}>Edad: {Edad === 0 ? "No especificada" : Edad} </p>
                                        <p style={{ margin: "0", padding: "0" }}>Tipo de sangre: {!!TipoSangre ? TipoSangre : "No especificada"} </p>
                                        <p style={{ margin: "0", padding: "0" }}>ID YGIA: {DatosContacto.id} </p>
                                    </div>
                                </div>
                                <div></div>
                            </div>
                        </div>
                        <div className="ExpedNewTabs" style={{ width: "100%" }}>
                            <ul>
                                <li
                                    className={OpcionSelectExp === 1 ? "liSelected" : ""}
                                    onClick={() => {
                                        setOpcionSelectExp(1);
                                    }}
                                >
                                    Historia clínica
                                </li>
                                <li
                                    className={OpcionSelectExp === 2 ? "liSelected" : ""}
                                    onClick={() => {
                                        setOpcionSelectExp(2);
                                    }}
                                >
                                    Notas médicas
                                </li>
                                <li
                                    className={OpcionSelectExp === 3 ? "liSelected" : ""}
                                    onClick={() => {
                                        setOpcionSelectExp(3);
                                    }}
                                >
                                    Recetas
                                </li>
                                <li
                                    className={OpcionSelectExp === 4 ? "liSelected" : ""}
                                    onClick={() => {
                                        setOpcionSelectExp(4);
                                    }}
                                >
                                    Estudios
                                </li>
                                <li
                                    className={OpcionSelectExp === 5 ? "liSelected" : ""}
                                    onClick={() => {
                                        setOpcionSelectExp(5);
                                        retrieveMedicalHistoryFiles();
                                    }}
                                >
                                    Documentos
                                </li>
                                {
                                    isPediatra ? (
                                        <li className={OpcionSelectExp === 6 ? "liSelected" : ""}
                                            onClick={() => {
                                                setOpcionSelectExp(6);
                                            }}
                                        >
                                            Gráficas
                                        </li>
                                    ) : null
                                }
                            </ul>
                        </div>
                        {OpcionSelectExp === 2 && (<>
                            <div style={{ padding: "1% 3%", display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                <Input
                                    prefix={<SearchIcon style={{ color: "#d7d7d7", width: "18px" }} />}
                                    style={{ width: "50%" }}
                                    placeholder="Buscar..."
                                    type="text"
                                    onChange={filterList}
                                />
                                {(data.Tipo === 1 && (<Button className="GeneralBoton " onClick={OpenModalAddNota} style={{ width: "100px", color: "white" }}>
                                    <Row style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        Nueva <AddCircleIcon style={{ fontSize: "15px" }} />
                                    </Row>
                                </Button>))}
                            </div>
                            <Row
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    fontWeight: "500",
                                    padding: ".5px 5%",
                                    color: "gray"
                                }}>
                                <p>Motivo de consulta</p> <p>Fecha y hora</p>
                            </Row>
                        </>
                        )}
                        {OpcionSelectExp === 3 && (
                            <>
                                <div style={{ margin: "1% 3%", display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                    <Input
                                        prefix={<SearchIcon style={{ color: "#d7d7d7", width: "18px" }} />}
                                        style={{ width: "50%" }}
                                        placeholder="Buscar..."
                                        type="text"
                                        onChange={filterList}
                                    />
                                    {(data.Tipo === 1 && (<Button className="GeneralBoton " onClick={OpenModalNuevaReceta} style={{ width: "100px", color: "white" }}>
                                        <Row style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            Nueva <AddCircleIcon style={{ fontSize: "15px" }} />
                                        </Row>
                                    </Button>))}
                                </div>
                                <Row
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        fontWeight: "500",
                                        padding: ".5px 5%",
                                        color: "gray"
                                    }}>
                                    <p>Folio</p> <p>Fecha y hora</p>
                                </Row>
                            </>
                        )}
                        {OpcionSelectExp === 4 && (<>
                            <div style={{ margin: "1% 3%", display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                <Input
                                    prefix={<SearchIcon style={{ color: "#d7d7d7", width: "18px" }} />}
                                    style={{ width: "50%" }}
                                    placeholder="Buscar..."
                                    type="text"
                                    onChange={filterList}
                                />
                                {(data.Tipo === 1 && (<Button className="GeneralBoton " onClick={OpenModalAddEstudi} style={{ width: "100px", color: "white" }}>
                                    <Row style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        Nueva <AddCircleIcon style={{ fontSize: "15px" }} />
                                    </Row>
                                </Button>))}
                            </div>
                            <Row
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    fontWeight: "500",
                                    padding: ".5px 5%",
                                    color: "gray"
                                }}>
                                <p>Descripción</p> <p>Fecha y hora</p> </Row>
                        </>
                        )}
                        {OpcionSelectExp === 5 && (<>
                            <div style={{ margin: "1% 3%", display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                <Input
                                    prefix={<SearchIcon style={{ color: "#d7d7d7", width: "18px" }} />}
                                    style={{ width: "50%" }}
                                    placeholder="Buscar..."
                                    type="text"
                                    onChange={filterList}
                                />
                                {(data.Tipo === 1 && (<Button className="GeneralBoton " onClick={OpenModalAddMedicalFile} style={{ width: "100px", color: "white" }}>
                                    <Row style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        Nueva <AddCircleIcon style={{ fontSize: "15px" }} />
                                    </Row>
                                </Button>))}
                            </div>
                        </>
                        )}
                    </>
                } />

            <Content
                style={{
                    // padding: '0 3%',
                    // position: "relative",
                    // width: "100%",
                    overflow: 'initial',
                }}
            >
                <Stack>

                    {OpcionSelectExp === 0 && <div></div>}
                    {OpcionSelectExp === 1 && (
                        <>
                            {loader ? <Loader /> : (
                                <NewHistorialClinico
                                    setEdad={setEdad}
                                    tipoSangreSet={setTipoSangre}
                                    Historial={Historial}
                                    getHistoriaClinica={getHistoriaClinica}
                                    mensajesError={
                                        {
                                            setOpen: setOpen,
                                            setTypeMessage: setTypeMessage,
                                            setMessage: setMessage,
                                        }
                                    }
                                    setLoader={setLoader}
                                    DatosContacto={DatosContacto}
                                />
                            )}
                        </>
                    )}
                    {OpcionSelectExp === 2 && (
                        <>
                            {loader ? <Loader /> : (
                                <ExpedienteNotasMedicas
                                    DatosContacto={DatosContacto}
                                    NotasEvolucion={NotasEvolucion}
                                    AccionesModal={
                                        {
                                            isOpenModalAddNota: isOpenModalAddNota,
                                            OpenModalAddNota: OpenModalAddNota,
                                            CloseModalAddNota: CloseModalAddNota
                                        }
                                    }
                                    AccionesMensaje={
                                        {
                                            setOpen: setOpen,
                                            setTypeMessage: setTypeMessage,
                                            setMessage: setMessage
                                        }
                                    }
                                />
                            )}
                        </>
                    )}
                    {OpcionSelectExp === 3 && (
                        <>
                            {loader ? <Loader /> : (
                                <RecetasExpedientes
                                    DatosContacto={DatosContacto}
                                    Recetas={ListaRecetas}
                                    getHistoria={getHistoriaClinica}
                                    AccionesModal={
                                        {
                                            isOpenModalNuevaReceta: isOpenModalNuevaReceta,
                                            OpenModalNuevaReceta: OpenModalNuevaReceta,
                                            CloseModalNuevaReceta: CloseModalNuevaReceta
                                        }
                                    }
                                    AccionesMensaje={
                                        {
                                            setOpen: setOpen,
                                            setTypeMessage: setTypeMessage,
                                            setMessage: setMessage
                                        }
                                    }
                                />
                            )}
                        </>
                    )}
                    {OpcionSelectExp === 4 && (
                        <>
                            {loader ? <Loader /> : (
                                <EstudiosExpediente
                                    DatosContacto={DatosContacto}
                                    Estudios={ListaEstudios}
                                    getHistoria={getHistoriaClinica}
                                    AccionesModal={
                                        {
                                            isOpenModalAddEstudi: isOpenModalAddEstudi,
                                            OpenModalAddEstudi: OpenModalAddEstudi,
                                            CloseModalAddEstudi: CloseModalAddEstudi,
                                            isOpenModalDetalleEstudi: isOpenModalDetalleEstudi,
                                            OpenModalDetalleEstudi: OpenModalDetalleEstudi,
                                            CloseModalDetalleEstudi: CloseModalDetalleEstudi,
                                        }
                                    }
                                    AccionesMensaje={
                                        {
                                            setOpen: setOpen,
                                            setTypeMessage: setTypeMessage,
                                            setMessage: setMessage
                                        }
                                    }
                                />
                            )}
                        </>
                    )}
                    {OpcionSelectExp === 5 && (
                        <DocumentHistoryFiles
                            contact={DatosContacto}
                            isOpenModal={isOpenModalAddMedicalFile}
                            closeModal={CloseModalAddMedicalFile}
                            documents={documentHistories}
                            reloadList={retrieveMedicalHistoryFiles}
                            loading={loadHistory}
                        />
                    )}
                    {
                        OpcionSelectExp === 6 && isPediatra ? (
                            <Box sx={{ padding: '2rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                <Box sx={{ marginBottom: '3rem', textAlign: 'center' }}>
                                    <Typography variant="h1" component="h2">Gráficas de crecimiento la OMS</Typography>
                                </Box>
                                {
                                    growthIndicators.length === 0 ? <CircularProgress /> : (
                                        <Grid container spacing={2}>
                                            <Grid item xs={6} sx={{ paddingRight: '1rem' }}>
                                                {/* curva de Crecimiento - Por talla LENGTH_HEIGHT_FOR_AGE */}
                                                <Box>
                                                    <GrowthChart data={growthIndicators.lengthHeightForAgeIndicator} />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={6} sx={{ paddingRight: '1rem' }}>
                                                {/* Curva de Crecimiento - Peso para la talla WEIGHT_FOR_LENGTH_HEIGHT */}
                                                <Box>
                                                    <GrowthChart data={growthIndicators.weightForLengthHeightIndicator} />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={6} sx={{ paddingRight: '1rem' }}>
                                                {/* Curva de Crecimiento - Peso por edad WEIGHT_FOR_AGE */}
                                                <Box>
                                                    <GrowthChart data={growthIndicators.weightForAgeIndicator} />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={6} sx={{ paddingRight: '1rem' }}>
                                                {/* Curva de Crecimiento - Perimetro cefalico HEAD_CIRCUMFERENCE_FOR_AGE */}
                                                <Box>
                                                    <GrowthChart data={growthIndicators.headCircumferenceForAgeIndicator} />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={6} sx={{ paddingRight: '1rem' }}>
                                                {/* Curva de Crecimiento - IMC BODY_MAX_INDEX_FOR_AGE */}
                                                <Box>
                                                    <GrowthChart data={growthIndicators.bodyMaxIndexForAgeIndicator} />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    )
                                }
                                <Divider />
                                <Box sx={{ marginTop: '2rem', padding: '1rem', width: '100%' }}>
                                    <Paper elevation={3} sx={{ padding: 3, marginTop: 4 }}>
                                        {
                                            vaccines.length === 0 ? <CircularProgress /> : <ImmunizationRecords records={vaccines} onUpdate={setVaccines} showControls={false} />
                                        }
                                    </Paper>
                                </Box>
                            </Box>
                        ) : null
                    }
                    <Snackbar
                        open={open}
                        autoHideDuration={6000}
                        onClose={() => setOpen(false)}
                    >
                        <Alert
                            onClose={() => setOpen(false)}
                            severity={typeMessage}
                            sx={{ width: "100%" }}
                        >
                            {message}
                        </Alert>
                    </Snackbar>
                </Stack >
            </Content>
        </Layout>

    );
}
